var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',_vm._b({attrs:{"value":_vm.value,"dir":"rtl"},on:{"input":$ev => _vm.$emit('input', $ev)}},'Select',_vm.$attrs,false),_vm._l((_vm.items),function(item,index){return _c('option',{key:index,attrs:{"disabled":item.disabled,"dir":"ltr"},domProps:{"value":item.value}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }